"use client";
import { Box } from "@chakra-ui/react";
import AdvantageCardList from "@/components/advantageCard";
import { LBGhoverEffect } from "styles/hoverPresets";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { MODELS_CONSTANTS } from "./constants";

const ModelsComp = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box
      border="1px solid #E2E8F0"
      borderRadius="2xl"
      p={{ base: 6, md: 10 }}
      boxShadow="lg"
    >
      <Heading variant={HeadingVariant} textAlign="center" mb={8}>
        GPU Profiles
      </Heading>

      <AdvantageCardList
        items={MODELS_CONSTANTS}
        hoverEffect
        hover={LBGhoverEffect}
        bgColor="gray.100"
      />
    </Box>
  );
};

export default ModelsComp;
